module.exports = __webpack_public_path__ + "static/img/authInstructions_page.aed3fcd2.png";